/**
 * HÄUM — Lógica de renta: depósito en garantía + botones de pago
 * ------------------------------------------------------------------
 * v4.2 — el deposito se busca por VARIANTE elegida (metacampo de variante, con el
 *   del producto como respaldo), y despues por el respaldo de palabras clave.
 * v4.1 — igual que la v4, pero con RESPALDO por palabra clave (corregido) cuando
 *   el producto no trae el metacampo. El metacampo siempre tiene prioridad.
 * v4 — agrega sobre la v3:
 *   1. Se reemplaza por completo el DEPOSITO_MAP de palabras clave por
 *      el metacampo custom.deposito_id del producto (leído vía el
 *      campo oculto properties[_deposito_variant_id] que inyecta el
 *      snippet Liquid en el formulario de "Agregar al carrito").
 *      El ID ya NO se adivina por el nombre del producto — viaja
 *      pegado a la línea del carrito como propiedad, así que un typo
 *      en el título, o dos productos con nombres parecidos, ya no
 *      pueden romper el enlace.
 *   2. Como consecuencia, cada línea de renta en el carrito sabe su
 *      propio depósito por sí misma (cart.items[i].properties
 *      ._deposito_variant_id) — no se necesita ningún mapa ni
 *      coincidencia de texto para eso. Detectar SI una línea del
 *      carrito ES un depósito (no cuál) se sigue haciendo por texto
 *      ("deposito" en el título), ya que eso no depende del producto
 *      en renta, sino del propio nombre del producto-depósito.
 */
(function () {
  'use strict';

  // Guardia anti-duplicado: si este script se llega a cargar dos veces en
  // la misma página (por ejemplo, por error en algún otro archivo), la
  // segunda copia se detiene aquí en vez de correr en paralelo y disparar
  // el doble de peticiones al carrito.
  if (window.__haumRentaCargado) return;
  window.__haumRentaCargado = true;

  function normalizar(str) {
    return (str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }


  // ---------------------------------------------------------------------
  // RESPALDO: mapa de palabras clave (el de la v3, ya corregido).
  // Solo se usa cuando el producto NO trae el metacampo/propiedad
  // _deposito_variant_id. Si el metacampo existe, SIEMPRE gana el metacampo.
  // Correcciones respecto a la v3: se compara por palabra completa (antes
  // "Mesa de Centro Bazzani" caia en "zani") y gana la coincidencia mas
  // larga (antes ganaba la ultima, y "Carlinini" terminaba con el deposito
  // de "Carli").
  // ---------------------------------------------------------------------
  var DEPOSITO_RESPALDO = {
    siena:52453776589090, stella:52453776589090, simone:52453776589090, scalone:52453776589090,
    silvetti:52389781143842, strambelli:52389781274914, santoro:52389781274914, santamaria:52389781274914,
    salvatori:52389781274914, segala:52389783994658, sorrentino:52389784879394, schettino:52389785567522,
    savini:52389785698594, siciliani:52389792284962, scaletti:52389792547106, scotti:52389796643106,
    carlinini:52453780259106, castellani:52453780259106, campisi:52453780259106, capriotti:52453780259106,
    corsini:52453780259106, cavallini:52453780259106, costanzo:52453780259106, cecchini:52453780259106,
    capelli:52453780259106, castelli:52453780455714, campi:52453780455714, capri:52453780455714,
    corsi:52453780455714, cavalli:52453780455714, costa:52453780455714, cannavaro:52453781143842,
    canavaro:52453781143842, carbonelo:52453783929122, carbone:52453783634210, cacciatore:52453781766434,
    cortesianni:52453781766434, castello:52453780685090, capellini:52453783142690, campanini:52453779636514,
    carlini:52453780095266, capone:52453784125730, coppola:52453777080610, carrozza:52453777080610,
    spinelli:52453776851234, caccia:52453781405986, cortesi:52453781405986, cocco:52453782257954,
    ciani:52453782257954, contini:52453783142690, cecchi:52453783142690, coluzzi:52453783142690,
    conti:52453782683938, campani:52453777604898, carli:52453779833122, tomassini:52302331085090,
    tomassi:52302323581218, tomaso:52302316765474, toma:52302307262754, tarantino:52302331412770,
    tarantini:52302329184546, taranti:52302328660258, tonino:52302331576610, tonini:52302329250082,
    toni:52302329184546, zattinoni:52302332657954, zerbonino:52302332657954, zattino:52302330986786,
    zerboni:52302330986786, zattini:52302330822946, zerbini:52302330822946, zannioni:52302332100898,
    zaninno:52302330757410, zanini:52302330528034, zattoni:52302330691874, zatti:52302330691874,
    zerbi:52302330691874, zani:52302329053474
  };
  var DEPOSITO_RESPALDO_CLAVES = Object.keys(DEPOSITO_RESPALDO).sort(function (a, b) { return b.length - a.length; });

  function depositoRespaldoParaTitulo(titulo) {
    var palabras = normalizar(titulo).split(/[^a-z0-9]+/).filter(Boolean);
    for (var i = 0; i < DEPOSITO_RESPALDO_CLAVES.length; i++) {
      if (palabras.indexOf(DEPOSITO_RESPALDO_CLAVES[i]) !== -1) return DEPOSITO_RESPALDO[DEPOSITO_RESPALDO_CLAVES[i]];
    }
    return null;
  }


  // ---------------------------------------------------------------------
  // MAPA POR VARIANTE (metacampos): el snippet Liquid deja en la pagina un
  // JSON { "idVariante": idDepositoVariante } — usa el metacampo de la
  // VARIANTE si existe y, si no, el del PRODUCTO. Asi cada variante (por
  // ejemplo Matrimonial / Queen / King) puede tener su propio deposito, y
  // el script no depende de que el formulario se vuelva a dibujar al
  // cambiar de variante: siempre busca por el id de variante elegido.
  // ---------------------------------------------------------------------
  function mapaDepositosPagina() {
    var el = document.getElementById('haum-deposito-map');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function depositoPorVariante(variantId) {
    var mapa = mapaDepositosPagina();
    if (!mapa || !variantId) return null;
    var n = parseInt(mapa[String(variantId)], 10);
    return isNaN(n) ? null : n;
  }

  // Detecta si una línea del carrito ES un depósito (sin importar a cuál
  // producto pertenece) — se sigue haciendo por texto porque el nombre
  // del producto-depósito ("Depósito en garantía...") es consistente,
  // a diferencia de antes, que también intentaba adivinar CUÁL depósito
  // era por el nombre del MUEBLE (eso es lo que ahora viene del metacampo).
  function esLineaDeDeposito(item) {
    var titulo = normalizar(item.product_title || item.title || '');
    return titulo.includes('deposito');
  }

  // Lee el ID de depósito que le corresponde a una línea de RENTA del
  // carrito — viene guardado como propiedad de línea
  // (properties._deposito_variant_id), puesta ahí al momento de agregar
  // el producto al carrito, tomada directo del metacampo del producto.
  function depositoVariantIdDeItem(item) {
    var props = item.properties || {};
    var val = props['_deposito_variant_id'];
    if (val) {
      var n = parseInt(val, 10);
      if (!isNaN(n)) return n;
    }
    // Sin propiedad: respaldo por nombre del producto.
    return depositoRespaldoParaTitulo(item.product_title || item.title || '');
  }

  // ---------------------------------------------------------------------
  // 2. Aviso visual de "sincronizando"
  // ---------------------------------------------------------------------
  var avisoEl = null;
  function mostrarAviso(mensaje) {
    if (!avisoEl) {
      avisoEl = document.createElement('div');
      avisoEl.id = 'haum-sync-aviso';
      avisoEl.style.cssText =
        'position:fixed;bottom:2rem;left:50%;transform:translateX(-50%);' +
        'background:rgba(0,0,0,.85);color:#fff;padding:.9rem 1.8rem;' +
        'border-radius:999px;font-size:1.3rem;z-index:99999;' +
        'transition:opacity .2s;pointer-events:none;';
      document.body.appendChild(avisoEl);
    }
    avisoEl.textContent = mensaje;
    avisoEl.style.display = 'block';
    avisoEl.style.opacity = '1';
  }
  function ocultarAviso() {
    if (!avisoEl) return;
    avisoEl.style.opacity = '0';
    setTimeout(function () {
      if (avisoEl) avisoEl.style.display = 'none';
    }, 250);
  }

  // ---------------------------------------------------------------------
  // 3. Fetch con reintento
  // ---------------------------------------------------------------------
  function fetchConReintento(url, options, intentosRestantes) {
    if (intentosRestantes === undefined) intentosRestantes = 2;
    return fetch(url, options)
      .then(function (r) {
        if (!r.ok) {
          var error = new Error('respuesta no OK: ' + r.status);
          error.status = r.status;
          throw error;
        }
        return r;
      })
      .catch(function (err) {
        if (intentosRestantes > 0) {
          // Ante un 429 (demasiadas peticiones) esperamos bastante más —
          // insistir rápido solo empeora la saturación.
          var espera = err && err.status === 429 ? 4000 : 800;
          return new Promise(function (resolve) {
            setTimeout(resolve, espera);
          }).then(function () {
            return fetchConReintento(url, options, intentosRestantes - 1);
          });
        }
        throw err;
      });
  }

  // ---------------------------------------------------------------------
  // 4. Refrescar contador del carrito (bubble) y contenido del drawer
  // ---------------------------------------------------------------------
  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function refrescarBubble() {
    fetch(cartUrl() + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var origen = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section');
        var destino = document.getElementById('cart-icon-bubble');
        if (origen && destino) destino.innerHTML = origen.innerHTML;
      })
      .catch(function () {});
  }

  function refrescarDrawerContenido() {
    if (!document.querySelector('cart-drawer-items')) return Promise.resolve();
    return fetch(cartUrl() + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var origen = doc.querySelector(sel);
          var destino = document.querySelector(sel);
          if (origen && destino) destino.replaceWith(origen);
        });
      })
      .catch(function () {});
  }

  // El drawer existe (oculto) incluso estando parado en /cart, así que
  // refrescar solo el drawer no alcanza si el cliente está viendo la
  // página completa del carrito — hay que refrescar también esa.
  function refrescarCartItemsContenido() {
    var mainItems = document.getElementById('main-cart-items');
    if (!mainItems) return Promise.resolve();
    // El identificador real de la sección es dataset.id (algo como
    // "template--XXXX__main-cart-items"), NO el texto fijo "main-cart-items"
    // — así es como el propio cart.js de Dawn lo pide, y usar el nombre
    // fijo hacía que Shopify regresara una respuesta que no traía nada útil.
    var seccionId = mainItems.dataset.id || 'main-cart-items';
    return fetch(cartUrl() + '?section_id=' + seccionId)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var origen = doc.querySelector('cart-items');
        if (origen) mainItems.innerHTML = origen.innerHTML;
      })
      .catch(function () {});
  }

  // Ligero, solo el total/subtotal — se llama SIEMPRE que cambie algo en el
  // carrito (no solo cuando el depósito necesitó ajuste), porque el total
  // en pantalla puede quedar desfasado del parche instantáneo aunque el
  // depósito en sí ya estuviera bien.
  function refrescarCartFooterContenido() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return Promise.resolve();
    var seccionId = footer.dataset.id || 'main-cart-footer';
    return fetch(cartUrl() + '?section_id=' + seccionId)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var origen = doc.querySelector('.js-contents');
        var destino = footer.querySelector('.js-contents');
        // Sin respaldo a "todo el footer": si no se encuentra el
        // contenedor exacto, mejor no tocar nada que reemplazar toda
        // la estructura (eso borraba el botón de pago y de paso
        // destruía el propio .js-contents, empeorando cada vez más).
        if (origen && destino) destino.innerHTML = origen.innerHTML;
      })
      .catch(function () {});
  }

  function refrescarCartPageContenido() {
    return Promise.all([refrescarCartItemsContenido(), refrescarCartFooterContenido()]);
  }

  function refrescarContenidoCarrito() {
    return Promise.all([refrescarDrawerContenido(), refrescarCartPageContenido()]);
  }

  // Después de una compra normal (sin renta), nos aseguramos de que el
  // cliente vea confirmación: refrescamos el contenido real y abrimos el
  // drawer si no se abrió solo. Esto reemplaza el "banner" que se perdía
  // cuando el widget de Seal interfería con la apertura nativa del tema.
  function confirmarAgregadoAlCarrito() {
    refrescarBubble();
    refrescarContenidoCarrito().then(function () {
      bloquearBotonesDeposito();
      // El tema usa "Notificación emergente", no drawer — el componente
      // real es <cart-notification>, con su propio método .open().
      var notif = document.querySelector('cart-notification');
      if (notif && typeof notif.open === 'function') {
        notif.open();
      }
    });
  }

  // ---------------------------------------------------------------------
  // 5. Página de producto: agregar depósito + producto en renta juntos,
  //    y ocultar pago rápido (Google Pay / Apple Pay) al elegir renta
  // ---------------------------------------------------------------------
  // El ID de depósito de ESTE producto ya no se busca por palabra clave —
  // se lee directo del campo oculto que el snippet Liquid puso dentro del
  // formulario de compra (viene del metacampo custom.deposito_id).
  function depositoDelProductoActual() {
    var campoId = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var porVariante = depositoPorVariante(campoId ? campoId.value : null);
    if (porVariante) return porVariante;
    var campo = document.querySelector('input[name="properties[_deposito_variant_id]"]');
    var val = campo ? parseInt(campo.value, 10) : NaN;
    if (!isNaN(val)) return val;
    return depositoRespaldoParaTitulo(window.HaumProductTitle || '');
  }

  function vigilarWidgetRenta() {
    function evaluarEstado() {
      var rentaChecked =
        document.querySelector('input.sls-option[data-type="subscription"]:checked') ||
        document.querySelector('.sls-selling-plan-group-first-line[aria-checked="true"] input[data-type="subscription"]');
      var compraChecked =
        document.querySelector('input.sls-option[data-type="one_time"]:checked') ||
        document.querySelector('.sls-selling-plan-group-first-line[aria-checked="true"] input[data-type="one_time"]');

      // Respaldo: plan precargado por URL puede no marcar el radio visual.
      var campoSellingPlan = document.querySelector('input[name="selling_plan"]');
      var tieneSellingPlan = !!(campoSellingPlan && campoSellingPlan.value);

      widgetIndicaRenta = (!!rentaChecked && !compraChecked) || (tieneSellingPlan && !compraChecked);
      aplicarOcultamientoExpress();
    }

    // Chequeo continuo (SIN saltar si "no cambió"): Shopify inserta los
    // widgets de pago rápido de forma asíncrona, después de que la página
    // ya cargó, así que hay que seguir re-aplicando aunque el estado
    // renta/compra no haya cambiado desde el último chequeo.
    setInterval(evaluarEstado, 400);
    evaluarEstado();
  }

  function initProductPage() {
    if (!window.location.pathname.includes('/products/')) return;

    var depositoVariantId = depositoDelProductoActual();
    if (depositoVariantId) {
      localStorage.setItem('deposito_variant_id', String(depositoVariantId));
    }

    vigilarWidgetRenta();

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form.matches('form[action*="/cart/add"]')) return;

        var rentaInput = form.querySelector('input.sls-option[data-type="subscription"]:checked');

        // Respaldo: si el plan viene precargado por URL (?selling_plan=...),
        // Seal a veces solo actualiza el campo oculto real sin marcar
        // visualmente el radio — así que también revisamos el campo que
        // de verdad se manda a Shopify, no solo el estado visual.
        var campoSellingPlan = form.querySelector('input[name="selling_plan"]');
        var tieneSellingPlan = !!(campoSellingPlan && campoSellingPlan.value);
        var esRenta = !!rentaInput || tieneSellingPlan;

        // Se relee directo del FormData (el estado real que se habría
        // enviado) en vez de la variable capturada al cargar la página —
        // más robusto si el formulario se vuelve a dibujar al cambiar de
        // variante, ya que esto siempre refleja lo que hay AHORA mismo.
        var formDataPrevia = new FormData(form);
        var depositoVariantIdActual = depositoPorVariante(formDataPrevia.get('id'));
        if (!depositoVariantIdActual) {
          var depositoIdCrudo = formDataPrevia.get('properties[_deposito_variant_id]');
          depositoVariantIdActual = depositoIdCrudo ? parseInt(depositoIdCrudo, 10) : null;
        }
        if (!depositoVariantIdActual || isNaN(depositoVariantIdActual)) {
          depositoVariantIdActual = depositoRespaldoParaTitulo(window.HaumProductTitle || '');
        }

        if (!esRenta || !depositoVariantIdActual) {
          // Compra normal (sin renta), o producto sin metacampo de
          // depósito configurado: no tocamos el envío nativo del
          // formulario, pero confirmamos que el drawer se abra con el
          // producto ya reflejado — por si el widget de Seal interfiere
          // con la apertura normal del tema.
          setTimeout(confirmarAgregadoAlCarrito, 900);
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        var formData = new FormData(form);
        var qty = parseInt(formData.get('quantity') || 1, 10);

        mostrarAviso('Agregando tu pedido, un momento…');

        var itemProducto = {
          id: parseInt(formData.get('id'), 10),
          quantity: qty,
          selling_plan: formData.get('selling_plan') || undefined,
          // Se guarda el ID de depósito como propiedad de línea — así
          // cart.items[].properties._deposito_variant_id queda disponible
          // más adelante para gruposRentaPorDeposito(), sin tener que
          // volver a adivinar nada por el nombre del producto. El guion
          // bajo al inicio del nombre hace que Shopify la oculte sola de
          // la vista del cliente en el carrito.
          properties: { _deposito_variant_id: String(depositoVariantIdActual) }
        };
        Object.keys(itemProducto).forEach(function (k) {
          if (itemProducto[k] === undefined) delete itemProducto[k];
        });

        fetchConReintento('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: depositoVariantIdActual, quantity: qty }, itemProducto]
          })
        })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            ocultarAviso();
            form.submit();
          });
      },
      true
    );
  }

  // ---------------------------------------------------------------------
  // 6. Lógica global de carrito (drawer + página completa, sin importar la URL)
  // ---------------------------------------------------------------------
  var sincronizando = false;
  var reintentoPendiente = false; // si llega un cambio mientras ya hay una sincronización en curso, no se pierde: se reintenta al terminar

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function totalRentaDe(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items
      .filter(function (i) { return i.selling_plan_allocation != null; })
      .reduce(function (s, i) { return s + i.quantity; }, 0);
  }

  // Agrupa las rentas del carrito por el depósito que les corresponde
  // (varios productos distintos pueden compartir el mismo depósito si así
  // se configuró en sus metacampos — aunque ahora, con un metacampo por
  // producto, lo normal es que cada uno tenga el suyo propio).
  // Regresa { variantIdDeDeposito: cantidadTotalDeRentaDeEseGrupo }.
  function gruposRentaPorDeposito(cart) {
    var grupos = {};
    if (!cart || !Array.isArray(cart.items)) return grupos;
    cart.items.forEach(function (item) {
      if (item.selling_plan_allocation == null) return; // no es renta
      var depId = depositoVariantIdDeItem(item);
      if (!depId) return; // producto en renta sin depósito mapeado — no se agrupa
      grupos[depId] = (grupos[depId] || 0) + item.quantity;
    });
    return grupos;
  }

  // Todas las líneas de depósito presentes ahora mismo en el carrito,
  // indexadas por su propio variant_id.
  function depositosEnCarrito(cart) {
    var mapa = {};
    if (!cart || !Array.isArray(cart.items)) return mapa;
    cart.items.forEach(function (item) {
      if (esLineaDeDeposito(item)) mapa[item.variant_id] = item;
    });
    return mapa;
  }

  // Actualiza SOLO la cantidad al instante — eso es simple y nunca se
  // equivoca, porque es un número que ya conocemos con certeza. El precio
  // de línea y el total YA NO se calculan aquí: intentar adivinarlos del
  // lado del cliente causaba números que a veces se quedaban pegados o
  // no cuadraban. Ahora esos esperan tantito a refrescarCartFooterContenido(),
  // que siempre trae el valor real confirmado por Shopify.
  function actualizarCantidadDepositoDOM(cart) {
    if (!cart) return;
    var grupos = gruposRentaPorDeposito(cart);

    document.querySelectorAll('cart-remove-button').forEach(function (wrapper) {
      var btn = wrapper.querySelector('button, a');
      if (!btn || !btn.dataset) return;
      var variantId = parseInt(btn.dataset.variantId, 10);
      var fila = wrapper.closest('tr, [class*="cart-item"], li');
      var textoFila = fila ? normalizar(fila.innerText || fila.textContent || '') : '';
      var esDeposito = textoFila.includes('deposito');
      if (!esDeposito || !fila) return;

      var cantidad = grupos[variantId];
      if (cantidad === undefined) return; // este depósito ya no corresponde a ninguna renta activa

      var input = fila.querySelector('.quantity__input, input[type="number"]');
      if (input) input.value = cantidad;
      var span = fila.querySelector('[class*="quantity"] span, .cart-item__quantity-text');
      if (span) span.textContent = cantidad;
    });
  }

  // Dawn ya trae el estado del carrito en el propio evento (cartData en el
  // pubsub, o detail en los CustomEvent que dispara esta misma página) —
  // lo usamos para el parche instantáneo en vez de esperar otro fetch.
  // OJO: product-form.js a veces publica este evento con cartData = solo
  // el artículo agregado (sin `.items`), no el carrito completo — hay que
  // validar la forma real antes de usarlo, o truena todo lo que escuche
  // este mismo evento después de nosotros (incluido el propio Dawn).
  function extraerCarritoDeEvento(evento) {
    if (!evento) return null;
    var candidato = evento.cartData || (evento.detail && (evento.detail.cart || evento.detail));
    if (candidato && Array.isArray(candidato.items)) return candidato;
    return null;
  }

  function sincronizarDeposito() {
    if (sincronizando) {
      reintentoPendiente = true;
      return;
    }
    sincronizando = true;
    mostrarAviso('Actualizando tu pedido, un momento…');

    var huboCambio = false;
    var cartInicial = null;

    fetchCart()
      .then(function (cart) {
        cartInicial = cart;
        var grupos = gruposRentaPorDeposito(cart); // { variantId: cantidadNecesaria }
        var depositos = depositosEnCarrito(cart); // { variantId: itemDeCarrito }
        var tareas = []; // funciones (thunks) que devuelven una promesa cada una

        // Ajustar o crear cada depósito que corresponde a un grupo con renta activa
        Object.keys(grupos).forEach(function (variantIdStr) {
          var variantId = parseInt(variantIdStr, 10);
          var cantidadNecesaria = grupos[variantIdStr];
          var itemDeposito = depositos[variantId];

          if (itemDeposito && itemDeposito.quantity !== cantidadNecesaria) {
            tareas.push(function () {
              huboCambio = true;
              return fetchConReintento('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: itemDeposito.key, quantity: cantidadNecesaria })
              });
            });
          } else if (!itemDeposito) {
            tareas.push(function () {
              huboCambio = true;
              return fetchConReintento('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: cantidadNecesaria })
              });
            });
          }
        });

        // Quitar depósitos huérfanos (ya no corresponden a ninguna renta activa)
        Object.keys(depositos).forEach(function (variantIdStr) {
          if (grupos[variantIdStr] === undefined) {
            tareas.push(function () {
              huboCambio = true;
              return fetchConReintento('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: depositos[variantIdStr].key, quantity: 0 })
              });
            });
          }
        });

        // Uno a la vez, no todos encimados — evita que choquen entre sí
        // contra el mismo carrito (esto es lo que probablemente causaba
        // que una cantidad se revirtiera sola al mezclar varios depósitos).
        return tareas.reduce(function (promesa, tarea) {
          return promesa.then(tarea);
        }, Promise.resolve());
      })
      .then(function () {
        sincronizando = false;
        ocultarAviso();
        // Reutilizamos el carrito que ya trajimos arriba en vez de que
        // refrescarUI() vuelva a pedirlo — evita duplicar la petición.
        if (cartInicial) actualizarBotonesUI(cartInicial);
        refrescarBubble();
        // El total/footer se refresca SIEMPRE, incluso si el depósito ya
        // estaba bien — porque el número en pantalla puede haber quedado
        // desfasado del parche instantáneo aunque el depósito en sí no
        // necesitara ningún ajuste real.
        refrescarCartFooterContenido();
        if (huboCambio) {
          refrescarContenidoCarrito().then(bloquearBotonesDeposito);
        }
        if (reintentoPendiente) {
          reintentoPendiente = false;
          sincronizarDeposito();
        }
      })
      .catch(function () {
        sincronizando = false;
        ocultarAviso();
        if (reintentoPendiente) {
          reintentoPendiente = false;
          sincronizarDeposito();
        }
      });
  }

  var SELECTORES_EXPRESS = [
    'button.accelerated-checkout-button',
    '.shopify-payment-button',
    '[data-shopify="payment-button"]',
    '.dynamic-checkout__content',
    '#dynamic-checkout-cart',
    '.additional-checkout-buttons',
    'shop-pay-button',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    'button.oak-checkout-button',
    '.cart__dynamic-checkout-buttons',
    '[id*="dynamic-checkout"]',
    // Confirmados por inspección real del DOM (agosto 2026):
    'shopify-google-pay-button',
    'shopify-apple-pay-button',
    'shopify-shop-pay-button',
    'shopify-pay-button',
    '#express-checkout-wallets-wrapper',
    '[id*="express-checkout-wallets"]'
  ].join(', ');

  // Dos contextos con reglas distintas — antes se mezclaban con OR y por
  // eso una renta ya existente en el carrito ocultaba el widget en OTRO
  // producto donde el cliente sí eligió "comprar". Ahora:
  //   - Dentro del carrito/drawer: manda el carrito real (carritoTieneRenta)
  //   - Fuera (la página de producto en sí): manda SOLO el widget de esa
  //     página (widgetIndicaRenta), sin importar qué haya en el carrito
  var widgetIndicaRenta = false;
  var carritoTieneRenta = false;

  function aplicarOcultamientoExpress() {
    document.querySelectorAll(SELECTORES_EXPRESS).forEach(function (el) {
      var esDeCarrito = !!el.closest(
        'cart-drawer, #CartDrawer, #main-cart-items, #main-cart-footer, cart-notification, #cart-notification'
      );
      var ocultar = esDeCarrito ? carritoTieneRenta : widgetIndicaRenta;
      el.style.setProperty('display', ocultar ? 'none' : '', 'important');
    });
  }

  // Shopify inserta estos widgets de forma asíncrona (a veces varios
  // segundos después de cargar la página). Este observer los cacha en
  // cuanto aparecen en el DOM, sin esperar al siguiente chequeo por
  // intervalo, y aplica el estado actual (oculto u ok) de inmediato.
  new MutationObserver(function (mutaciones) {
    var hayNuevoWidget = mutaciones.some(function (m) {
      return Array.from(m.addedNodes || []).some(function (n) {
        if (n.nodeType !== 1) return false;
        return n.matches && (n.matches(SELECTORES_EXPRESS) || n.querySelector(SELECTORES_EXPRESS));
      });
    });
    if (hayNuevoWidget) aplicarOcultamientoExpress();
  }).observe(document.documentElement, { childList: true, subtree: true });

  var SELECTORES_CHECKOUT = [
    '[name="checkout"]',
    'button[type="submit"][id*="checkout"]',
    'a[href="/checkout"]',
    '.cart__checkout-button',
    '#checkout',
    '#CartDrawer-Checkout',
    'button.cart__checkout',
    'input[name="checkout"]'
  ].join(', ');

  function actualizarBotonesUI(cart) {
    var tieneRenta = totalRentaDe(cart) > 0;

    document.querySelectorAll(SELECTORES_CHECKOUT).forEach(function (btn) {
      btn.textContent = tieneRenta ? 'Iniciar mi plan de renta' : 'Pagar a MSI';
    });

    carritoTieneRenta = tieneRenta;
    aplicarOcultamientoExpress();
  }

  function refrescarUI() {
    fetchCart().then(actualizarBotonesUI);
  }

  // ---- Bloquear la eliminación Y la modificación de cantidad del depósito ----
  function bloquearBotonesDeposito() {
    document.querySelectorAll('cart-remove-button').forEach(function (wrapper) {
      // Antes solo buscaba <button> y se rendía si no lo encontraba. La
      // página de carrito completa (/cart) puede usar <a> en vez de
      // <button> (distinto al drawer), así que buscamos cualquiera.
      var btn = wrapper.querySelector('button, a');
      if (!btn) return;

      var fila = wrapper.closest('tr, [class*="cart-item"], li');
      var textoFila = fila ? normalizar(fila.innerText || fila.textContent || '') : '';
      var labelBtn = normalizar(btn.getAttribute('aria-label') || '');
      var esDeposito = textoFila.includes('deposito') || labelBtn.includes('deposito');

      if (!esDeposito) return;

      if (!btn.dataset.haumHandled) {
        btn.dataset.haumHandled = 'true';
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
          },
          true
        );
        btn.style.opacity = '0.35';
        btn.style.pointerEvents = 'none';
        btn.setAttribute('aria-disabled', 'true');
        btn.title = 'El depósito se ajusta automáticamente junto con tu renta';
      }

      if (fila && !fila.dataset.haumQtyLocked) {
        fila.dataset.haumQtyLocked = 'true';

        var input = fila.querySelector('.quantity__input, input[type="number"]');
        if (input) {
          input.setAttribute('readonly', 'readonly');
          input.style.pointerEvents = 'none';
          input.style.opacity = '0.5';
          input.title = 'La cantidad del depósito se ajusta sola según tu renta';
        }

        fila.querySelectorAll('.quantity__button').forEach(function (b) {
          b.disabled = true;
          b.style.opacity = '0.3';
          b.style.pointerEvents = 'none';
        });
      }
    });
  }

  // ---------------------------------------------------------------------
  // 7. Enganche a eventos reales del tema (en vez de vigilar la URL)
  // ---------------------------------------------------------------------
  function onCartChanged(evento) {
    try {
      var cart = extraerCarritoDeEvento(evento);
      if (cart) {
        // Parche visual instantáneo con los datos que Dawn ya trae a mano.
        actualizarCantidadDepositoDOM(cart);
      }
      bloquearBotonesDeposito();
      sincronizarDeposito(); // confirma/corrige de verdad contra el servidor
    } catch (err) {
      // Nunca dejamos que un error nuestro interrumpa a otros suscriptores
      // del mismo evento (pubsub.js usa Array.map — un throw aquí corta
      // en seco cualquier cosa que Dawn tuviera pendiente después).
      console.error('[haum-renta] onCartChanged:', err);
    }
  }

  // Varias vías (evento nativo de Dawn + nuestro propio respaldo por clic)
  // pueden disparar esto casi al mismo tiempo para UNA sola acción del
  // usuario. Sin amortiguar, cada disparo hace su propio refresco del
  // total por separado y se pisan entre sí — se ve como que el total
  // "parpadea" o desaparece un instante. Colapsamos todo en una sola
  // ejecución real por ráfaga de eventos.
  var onCartChangedTimer = null;
  function onCartChangedAmortiguado(evento) {
    if (onCartChangedTimer) clearTimeout(onCartChangedTimer);
    onCartChangedTimer = setTimeout(function () {
      onCartChangedTimer = null;
      onCartChanged(evento);
    }, 900);
  }

  // window.subscribe / window.PUB_SUB_EVENTS puede no existir si pubsub.js
  // declaró esas variables con const/let (top-level) — en scripts clásicos
  // eso NO se convierte en propiedad de window, aunque siga siendo
  // referenciable como variable suelta. typeof nunca truena aunque la
  // variable no exista, así que es seguro probar así.
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartChangedAmortiguado);
    }
  } catch (e) {}

  document.addEventListener('cart:updated', onCartChangedAmortiguado);
  document.addEventListener('theme:cart:update', onCartChangedAmortiguado);

  // Respaldo directo, sin depender de pubsub.js en absoluto: escucha
  // directamente los clics en +/-, quitar, y cambios en el input de
  // cantidad, en cualquier parte del documento (drawer o /cart).
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('.quantity__button') || e.target.closest('cart-remove-button')) {
        onCartChangedAmortiguado();
      }
    },
    true
  );
  document.addEventListener(
    'change',
    function (e) {
      if (e.target.matches && e.target.matches('.quantity__input, input[type="number"]')) {
        onCartChangedAmortiguado();
      }
    },
    true
  );

  setInterval(function () {
    bloquearBotonesDeposito();
    if (!sincronizando) {
      sincronizarDeposito(); // ya actualiza los botones internamente, sin fetch aparte
    }
  }, 20000);

  document.addEventListener('DOMContentLoaded', function () {
    initProductPage();
    bloquearBotonesDeposito();
    refrescarUI();
  });
})();